export const API_RESPONSE_SUCCESS = 'API_RESPONSE_SUCCESS';
export const API_RESPONSE_ERROR = 'API_RESPONSE_ERROR';

export const GET_ACCOUNTS = 'GET_ACCOUNTS';
export const GET_ACCOUNT_BY_ID = 'GET_ACCOUNT_BY_ID';
export const CREATE_ACCOUNTS = 'CREATE_ACCOUNTS';
export const UPDATE_ACCOUNTS = 'UPDATE_ACCOUNTS';
export const DELETE_ACCOUNTS = 'DELETE_ACCOUNTS';
